export function formatCaseUnits(totalUnits: number, unitsPerCase: number): string {
  const upc = Math.max(1, Math.floor(unitsPerCase) || 1);
  const total = Math.max(0, Math.floor(totalUnits) || 0);
  const cases = Math.floor(total / upc);
  const leftover = total % upc;
  if (leftover === 0) return `${cases} cs`;
  return `${cases} cs + ${leftover} u`;
}

export function deriveTotalUnits(
  casesReceived: number,
  leftoverUnits: number,
  unitsPerCase: number
): number {
  const upc = Math.max(1, Math.floor(unitsPerCase) || 1);
  const cases = Math.max(0, Math.floor(casesReceived) || 0);
  const leftover = Math.max(0, Math.floor(leftoverUnits) || 0);
  return cases * upc + leftover;
}

export function deriveCasesPerPallet(
  casesPerLayer: number | null | undefined,
  layersPerPallet: number | null | undefined
): number | null {
  if (casesPerLayer == null || layersPerPallet == null) return null;
  const cpl = Math.floor(casesPerLayer);
  const lpp = Math.floor(layersPerPallet);
  if (cpl <= 0 || lpp <= 0) return null;
  return cpl * lpp;
}
